export const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  }
};

export const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args);
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
};

export const waitForCondition = function (condition,retryEveryMs=200,maxMs=5000){
  return new Promise((resolve, reject)=>{
    let waitTime=0;
    const tempInterval=setInterval(()=>{
      let result=false;
      try{
        result=condition();
      }catch (e) {console.error(e)}

      if(result || waitTime > maxMs){
        clearInterval(tempInterval);
        if(waitTime>maxMs){
          reject('timeout');
        }else{
          resolve();
        }
      }
      waitTime+=retryEveryMs;
    },retryEveryMs);
});
};
